//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import dayjs from 'dayjs' // 时间转换
import { bus } from '~/assets/js/eventBus'
export default {
  data () {
    return {
      count: 0,
      showfenxian: false,
      // GuoJiDianWei: this.$store.state.riskcontrol['271001'], // 点位控制[国际]
      // GuoNeiDianWei: this.$store.state.riskcontrol['271002'], // 点位控制[国内]
      curtime: '',
      step: '',
      ss: ''
    }
  },
  computed: {
    ...mapState({
      riskShow: 'riskShow',
      cookieHost: 'cookieHost'
    })
  },
  mounted () {
    this.getRiskModule()
    // console.log('pingbi-gj', this.GuoJiDianWei)
    // console.log('pingbi-gn', this.GuoNeiDianWei)
  },
  methods: {
    getRiskModule () {
      let ss = ''
      ss += 'ck-1111'
      const that = this
      if (!this.curtime) {
        this.curtime = dayjs().format('YYYY-MM-DD HH:mm:ss')
      }
      ss += 'ck-2222'
      const jgpass = this.$Cookie.get('jgpass_new')
      const myip = this.$store.state.userIp
      if (!myip) {
        console.log('this.$store.state.userIp取值异常1,ip=' + myip)
      }
      ss += 'ck-3333'
      const myCountry = this.$store.state.myCountry
      ss += '(myCountry=' + myCountry + ')'
      if (!myCountry) {
        console.log('this.$store.state.myCountry异常,数据丢失,myCountry =' + myCountry)
      }
      ss += 'ck-4444'
      // const popred = (this.$store.state.isWiki == '1' ? (this.GuoJiDianWei == '1') : (this.GuoNeiDianWei == '1'))
      // ss += '[popred=' + popred + ']'
      /*  && popred */
      if (jgpass != '1') {
        ss += 'ck-5555'
        if (myCountry == 'cn') {
          that.showfenxian = true
          ss += 'ck-6666'
          // this.ipInChinaFn(function () {
          //   ss += 'ck-7777'
          //   that.showfenxian = false
          // }, function () {
          //   ss += 'ck-8888'
          //   that.showfenxian = true
          //   bus.$emit('popRiskRed', true)
          // })
        } else {
          that.showfenxian = false
          ss += 'ck-9999'
          bus.$emit('popRiskRed', true)
        }
        ss += 'ck-aaaa'
      }
      ss += 'ck-bbbb'
      ss += '(showfenxian=' + that.showfenxian + ')'
      this.ss = ss
    },
    AddTime (time) {
      let dateTime = new Date()
      dateTime = new Date(dateTime.setTime(dateTime.getTime() + time * 1000))
      return dateTime
    },
    ipInChinaFn (func1, func2) {
      const imgurl = 'https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png?ts=' + Math.random()
      const img = new Image()
      this.ss += 'p-111,'
      let flag = false
      let isCloseWifi = true
      let hasFinish = false
      img.onload = function () {
        this.ss += 'p-222,'
        if (!hasFinish) {
          this.ss += 'p-333,'
          flag = true
          hasFinish = true
          img.src = imgurl
          console.log('Ping ' + imgurl + ' success. ')
          func1()
        }
      }
      this.ss += 'p-444,'
      img.onerror = function () {
        this.ss += 'p-555,'
        if (!hasFinish) {
          this.ss += 'p-666,'
          if (!isCloseWifi) {
            this.ss += 'p-777,'
            flag = true
            img.src = imgurl
            console.log('Ping ' + imgurl + ' error. ')
            func1() // ping到了服务器,图片显示错误之类的,只要有快速返回,也算能ping通
          }
          this.ss += 'p-888,'
          hasFinish = true
        }
        this.ss += 'p-999,'
      }
      setTimeout(function () {
        this.ss += 'p-aaa,'
        isCloseWifi = false
      }, 2)
      this.ss += 'p-bbb,'
      img.src = imgurl
      this.ss += 'p-ccc,'
      setTimeout(function () {
        this.ss += 'p-ddd,'
        if (!flag) {
          this.ss += 'p-eee,'
          hasFinish = true
          img.src = imgurl
          this.ss += 'p-fff,'
          flag = false
          console.log('Ping ' + imgurl + ' error. ')
          func2()
        }
        this.ss += 'p-ggg,'
      }, 1500)
      this.ss += 'p-hhh,'
    },
    eventclick () {
      this.count++
      if (this.count >= 7) {
        this.$Cookie.set('jgpass_new', '1', { path: '/', expires: this.AddTime(720 * 60), domain: this.cookieHost })
        window.location.reload()
      }
      setTimeout(() => {
        this.count = 0
      }, 30000)
    }
  }
}
